import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';
import useSWR from 'swr';
import { APIDestination } from '../../../../../../../../typings/Destination.interface';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import Button from '../../../../common/base/Button';
import Container from '../../../../common/base/Container';
import Loading from '../../../../common/base/Loading';
import Tabs from '../../../../common/base/Tabs';
import Text from '../../../../common/base/Text';
import EmptyState from '../../../../common/EmptyState';
import { Div } from '../../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { withTeamPermission } from '../../../../contexts/TeamPermissionContext';
import { StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, ViewBreadcrumbsTitle } from '../../../../layouts/ViewLayout';
import NotFound from '../../NotFound';
import { DestinationConnections } from './DestinationConnections';
import { DestinationDeliveryGroups } from './DestinationDeliveryGroups';
import { getDestinationDeliveryPolicy } from '../Forms/destination_configuration';
import { DestinationMetrics } from './DestinationMetrics';
import { DestinationOverview } from './DestinationOverview';
import { DestinationSettings } from './DestinationSettings';
const DestinationView = t0 => {
  const $ = _c(80);
  const {
    id: id_prop,
    mutate_destinations
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const theme = useTheme();
  const {
    params: t1
  } = useRouteMatch();
  const {
    id: id_param
  } = t1;
  const id = id_prop || id_param;
  const location = useLocation();
  let t2;
  if ($[0] !== id) {
    t2 = APIMethodKeys.destinations.get(id, {
      include: "config.auth"
    });
    $[0] = id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== HookdeckAPI.destinations || $[3] !== id) {
    t3 = () => HookdeckAPI.destinations.get(id, {
      include: "config.auth"
    });
    $[2] = HookdeckAPI.destinations;
    $[3] = id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: destination,
    mutate,
    error
  } = useSWR(t2, t3);
  let t4;
  if ($[5] !== destination) {
    t4 = destination ? APIMethodKeys.webhooks.count({
      destination_id: destination.id
    }) : null;
    $[5] = destination;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== HookdeckAPI.webhooks || $[8] !== destination?.id) {
    t5 = () => HookdeckAPI.webhooks.count({
      destination_id: destination?.id
    });
    $[7] = HookdeckAPI.webhooks;
    $[8] = destination?.id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    data: connections_count
  } = useSWR(t4, t5);
  let t6;
  if ($[10] !== mutate || $[11] !== mutate_destinations) {
    t6 = destination_0 => {
      mutate(destination_0);
      mutate_destinations?.();
    };
    $[10] = mutate;
    $[11] = mutate_destinations;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const mutate_all = t6;
  if (error && error.response?.status === 404) {
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        to: "/connections",
        text: "All Connections"
      };
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== id) {
      t8 = <NotFound title="Destination not found" description="This destination does not exist or has been deleted." id={id} link={t7} />;
      $[14] = id;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  if (error && error.response?.status === 410) {
    let t7;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        justify: "center"
      };
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Text semi={true} center={true} size="l">Destination deleted</Text>;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Text as="p" m={{
        t: 4,
        b: 2
      }}>This destination was permanently deleted.</Text>;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <StyledViewLayout><StyledViewContent><Div flex={t7} p={8}><Container small={true} center={true}>{t8}{t9}<Button primary={true} ghost={true} m={{
                t: 4
              }} as={RouterLink} to="/connections">Connections</Button></Container></Div></StyledViewContent></StyledViewLayout>;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    return t10;
  }
  if (!destination) {
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Div m={{
        t: 8
      }}><Loading /></Div>;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    return t7;
  }
  const t7 = destination?.name || id;
  let t8;
  if ($[21] !== t7) {
    t8 = {
      label: t7,
      highlight: true
    };
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const title_breadcrumb = t8;
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      label: "Destinations",
      to: "/destinations"
    };
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== title_breadcrumb) {
    t10 = [t9, title_breadcrumb];
    $[24] = title_breadcrumb;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const breadcrumbs = t10;
  let t11;
  if ($[26] !== destination) {
    t11 = getDestinationDeliveryPolicy(destination)?.groups;
    $[26] = destination;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const delivery_groups_configured = !!t11;
  const t12 = `/destinations/${id}`;
  let t13;
  if ($[28] !== t12) {
    t13 = {
      label: "Overview",
      key: "overview",
      to: t12
    };
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = `/destinations/${id}/metrics`;
  let t15;
  if ($[30] !== t14) {
    t15 = {
      label: "Metrics",
      key: "metrics",
      to: t14
    };
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const t16 = `/destinations/${id}/delivery-groups`;
  let t17;
  if ($[32] !== t16) {
    t17 = {
      label: "Delivery groups",
      key: "delivery-groups",
      to: t16
    };
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const t18 = `/destinations/${id}/connections`;
  const t19 = connections_count?.count;
  let t20;
  if ($[34] !== t18 || $[35] !== t19) {
    t20 = {
      label: "Connections",
      key: "connections",
      to: t18,
      badge_label: t19,
      badge_theme: "muted"
    };
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const t21 = `/destinations/${id}/settings`;
  let t22;
  if ($[37] !== t21) {
    t22 = {
      label: "Settings",
      key: "settings",
      to: t21
    };
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t13 || $[40] !== t15 || $[41] !== t17 || $[42] !== t20 || $[43] !== t22) {
    t23 = {
      OVERVIEW: t13,
      METRICS: t15,
      DELIVERY_GROUPS: t17,
      CONNECTIONS: t20,
      SETTINGS: t22
    };
    $[39] = t13;
    $[40] = t15;
    $[41] = t17;
    $[42] = t20;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  const TABS = t23 as const;
  let t24;
  if ($[45] !== breadcrumbs) {
    t24 = <StyledViewNavHeader><ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} /></StyledViewNavHeader>;
    $[45] = breadcrumbs;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== location.pathname) {
    t25 = location.pathname.split("/")[3] || "overview";
    $[47] = location.pathname;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== TABS) {
    t26 = Object.values(TABS);
    $[49] = TABS;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  const t27 = t26 as any[];
  let t28;
  if ($[51] !== t25 || $[52] !== t27) {
    t28 = <StyledViewNavSecondary><Tabs active_tab={t25} border={false} tabs={t27} /></StyledViewNavSecondary>;
    $[51] = t25;
    $[52] = t27;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t24 || $[55] !== t28) {
    t29 = <StyledViewNav>{t24}{t28}</StyledViewNav>;
    $[54] = t24;
    $[55] = t28;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== destination) {
    t30 = <Route exact={true} path="/destinations/:id" render={() => <DestinationOverview destination={destination} />} />;
    $[57] = destination;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== destination) {
    t31 = <Route path="/destinations/:id/metrics" render={() => <DestinationMetrics destination={destination} />} />;
    $[59] = destination;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== destination) {
    t32 = <Route path="/destinations/:id/connections" render={() => <DestinationConnections destination={destination} />} />;
    $[61] = destination;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] !== delivery_groups_configured || $[64] !== destination || $[65] !== mutate_all || $[66] !== theme) {
    t33 = <Route path="/destinations/:id/delivery-groups" render={() => delivery_groups_configured ? <DestinationDeliveryGroups destination={destination} mutate={mutate_all} /> : <EmptyState title="Delivery groups" description="Set delivery rates for keys extracted from your webhook payload body, headers, query, or path. Monitor their status with per-tenant queue depth, throughput, and backlog age metrics." asset={`delivery_groups-bg-${theme.mode}.png`} asset_position="background" cta={{
      label: "Configure delivery groups",
      icon: "settings",
      to: `/destinations/${destination.id}/settings`
    }} />} />;
    $[63] = delivery_groups_configured;
    $[64] = destination;
    $[65] = mutate_all;
    $[66] = theme;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  let t34;
  if ($[68] !== destination || $[69] !== mutate_all) {
    t34 = <Route path="/destinations/:id/settings" render={() => <DestinationSettings destination={destination} mutate={mutate_all} />} />;
    $[68] = destination;
    $[69] = mutate_all;
    $[70] = t34;
  } else {
    t34 = $[70];
  }
  let t35;
  if ($[71] !== t30 || $[72] !== t31 || $[73] !== t32 || $[74] !== t33 || $[75] !== t34) {
    t35 = <Switch>{t30}{t31}{t32}{t33}{t34}</Switch>;
    $[71] = t30;
    $[72] = t31;
    $[73] = t32;
    $[74] = t33;
    $[75] = t34;
    $[76] = t35;
  } else {
    t35 = $[76];
  }
  let t36;
  if ($[77] !== t29 || $[78] !== t35) {
    t36 = <StyledViewLayout><StyledViewContent>{t29}{t35}</StyledViewContent></StyledViewLayout>;
    $[77] = t29;
    $[78] = t35;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  return t36;
};
export default withTeamPermission(DestinationView, 'member');